/**
 * Reports Redirect Component
 *
 * Redirects /okr/reports to /okr with a toast notification.
 * The reports page has been removed.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '@/hooks/useToast';

export default function ReportsRedirect() {
  const toast = useToast();

  useEffect(() => {
    toast.info('Relatórios foram removidos.');
  }, [toast]);

  return <Navigate to="/okr" replace />;
}
